import { createFileRoute } from '@tanstack/react-router';
import { requireFeature } from '@portal/platform/guards';
import { useShellTexts } from '@portal/ui';

/**
 * The dealer portal's landing page. The full tyre-metrics dashboard is tyre-analytics-portal's.
 *
 * The welcome text is the shell catalogue's: Angular read `dashboardHomeTitle` /
 * `dashboardHomeSubtitle` from the configuration, but no schema defines them, so Angular always
 * showed its hardcoded fallback. See docs/dealer-portal-react/shell.md.
 */
export const Route = createFileRoute('/_app/dashboard')({
  staticData: { featureKey: 'dashboard' },
  beforeLoad: ({ context, location }) =>
    requireFeature(context, location, { feature: 'dashboard' }),
  component: Dashboard,
});

function Dashboard() {
  const t = useShellTexts().dashboard;
  return (
    <section className="mx-auto max-w-3xl px-6 py-12">
      <h1 className="mb-3 text-3xl font-semibold tracking-tight text-gray-900">{t.welcomeTitle}</h1>
      <p className="text-base leading-relaxed text-slate-600">{t.welcomeSubtitle}</p>
    </section>
  );
}
